import { render, staticRenderFns } from "./NotificationCount.vue?vue&type=template&id=5042b779&scoped=true"
import script from "./NotificationCount.vue?vue&type=script&lang=ts"
export * from "./NotificationCount.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5042b779",
  null
  
)

export default component.exports